import type { UserPrivateProfile } from '#shared/types/User'

import { isPhoneNumber } from '@/validators/isPhoneNumber'
import { isEmail, isRequired, validate } from 'last-validator'

export function validateEmail(email: string) {
    return validate<{ email: string }>(
        { email },
        {
            email: [isRequired(), isEmail()]
        }
    )
}

export function validatePrivateProfile(privateProfile: UserPrivateProfile) {
    return validate<UserPrivateProfile>(privateProfile, {
        contactEmail: [isRequired(), isEmail()],
        phone: [isPhoneNumber]
    })
}
